import { render, staticRenderFns } from "./StoreTag.vue?vue&type=template&id=72b7d1a7&scoped=true"
import script from "./StoreTag.vue?vue&type=script&lang=js"
export * from "./StoreTag.vue?vue&type=script&lang=js"
import style0 from "./StoreTag.vue?vue&type=style&index=0&id=72b7d1a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b7d1a7",
  null
  
)

export default component.exports